import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'declension'
})
export class DeclensionPipe implements PipeTransform {

  transform(quantity: number): string {
    if (quantity % 1 === 0) {
      let words: string[] = ['упаковка', 'упаковки', 'упаковок'];
      let result: string = words[quantity%10==1 && quantity%100!=11 ? 0 : quantity%10>=2 && quantity%10<=4 && (quantity%100<10 || quantity%100>=20) ? 1 : 2];
      return quantity + ' ' + result
    }
  }
}
